import { z } from 'zod';
/**
 * Contrato de `GET /health`. Es el primer contrato compartido web ↔ api y existe
 * para que el monorepo demuestre la regla: ningún dato cruza el límite sin schema.
 */
export const healthStatusSchema = z.enum(['ok', 'degraded']);
export const healthResponseSchema = z.object({
    status: healthStatusSchema,
    /** Nombre del servicio que responde. */
    service: z.literal('pasos-api'),
    /** Versión desplegada; en local es la del package.json. */
    version: z.string().min(1),
    /** Momento de la respuesta en ISO 8601 UTC. */
    timestamp: z.iso.datetime(),
    /** Segundos que lleva el proceso en pie. */
    uptimeSeconds: z.number().nonnegative(),
});
//# sourceMappingURL=health.js.map